import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';




var xhttp = new XMLHttpRequest();
var data = {};
xhttp.onreadystatechange = function() {
    if (this.readyState === 4 && this.status === 200) {
       // Typical action to be performed when the document is ready:
       data = JSON.parse(xhttp.responseText);
       ReactDOM.render(<App appData={data}/>, document.getElementById('calculator'));
    }
};

xhttp.open("GET", `${process.env.PUBLIC_URL}/DefultData.json`, true);
xhttp.send();
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js